<div class="musicthon-wrapper">
  @if (isEnabled()) {
  <!-- Card de ROUBO substituindo o player -->
  <div
    class="steal-takeover-card"
    [@stealFlash]
    [class.hidden]="!showStealCard"
  >
    <div class="steal-rhino-bg">
      <img src="assets/images/logo_index.png" alt="Rhyno" class="rhino-image" />
    </div>
    <div class="steal-content">
      <div class="steal-announcement">
        <span class="steal-name">{{ stealCardDonorName || "Alguém" }}</span>
        <span class="steal-action">ROUBOU!</span>
      </div>
      @if (stealCardAmount !== null) {
      <div class="steal-value">{{ formatAmount(stealCardAmount) }}</div>
      }
    </div>
    <div class="steal-lightning-effect"></div>
  </div>

  <!-- Player normal -->
  <div
    class="panel"
    [class.playing]="playbackState === 'playing'"
    [class.hidden]="showStealCard"
  >
    <div class="header">
      <div class="brand">
        <img class="brand-avatar" src="assets/images/logo_index.png" />
        <span>Baile do Rhyno</span>
        @if (providerLabel()) {
        <span class="provider-badge">
          <img
            class="provider-icon"
            [src]="providerIcon()"
            [alt]="providerLabel()"
          />
        </span>
        }
      </div>
      <div class="controls">
        @if (playbackState === 'paused') {
        <mat-icon class="active">pause</mat-icon>
        } @else {
        <mat-icon class="active">play_arrow</mat-icon>
        }
      </div>
    </div>

    <div class="now-playing">
      <div class="header-line">
        <div class="label">
          @if (playbackState === 'paused') { Pausado } @else { Tocando }
        </div>
        @if (currentDonorName || currentAmount !== null) {
        <div class="donor-line-container">
          @if (currentDonorName) {
          <span class="donor-name">{{ currentDonorName }}</span>
          }
          @if (currentAmount !== null) {
          <span class="donor-value">{{ formatAmount(currentAmount) }}</span>
          }
        </div>
        }
      </div>
      <div class="track">{{ formatCurrentTitle() }}</div>
      <div
        class="wave"
        [class.paused]="playbackState !== 'playing'"
        [class.intensity-low]="beatIntensity === 'low'"
        [class.intensity-medium]="beatIntensity === 'medium'"
        [class.intensity-high]="beatIntensity === 'high'"
        [class.intensity-drop]="beatIntensity === 'drop'"
        aria-hidden="true"
      >
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
        <span class="wave-bar"></span>
      </div>
    </div>

    <!-- Informações do dono da pista integradas -->
    <!-- @if (currentDonorName || currentAmount) {
          <div class="track-owner-inline">
            <div class="owner-badge-inline">
              <mat-icon class="crown-icon-inline">emoji_events</mat-icon>
              <span class="owner-label">DONO DA PISTA</span>
            </div>
            <div class="owner-info-inline">
              @if (currentDonorName) {
                <span class="owner-name-inline">{{ currentDonorName }}</span>
              }
              @if (currentAmount !== null) {
                <span class="owner-amount-inline">{{ formatAmount(currentAmount) }}</span>
              }
            </div>
          </div>
        } -->

    <app-musicthon-player
      #player
      [showVideo]="showVideo"
      [volume]="playbackVolume"
      (ended)="onEnded()"
      (error)="onError($event)"
      (ready)="onReady()"
      (playing)="onPlaying()"
    ></app-musicthon-player>
  </div>
  }
</div>
